import { render } from "./PreschoolMyGroupsContent.vue?vue&type=template&id=006a2f62&ts=true"
import script from "./PreschoolMyGroupsContent.vue?vue&type=script&lang=ts"
export * from "./PreschoolMyGroupsContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__